import { Link, Outlet, useRouterState } from '@tanstack/react-router';

const TABS = [
  { to: '/settings/users', label: 'Users' },
  { to: '/settings/review', label: 'Review flow' },
  { to: '/settings/org', label: 'Organization' },
] as const;

export function Settings(): JSX.Element {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="page-narrow space-y-6">
      <header>
        <h1 className="font-serif text-3xl tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage your workspace and organization.</p>
      </header>
      <nav aria-label="Settings sections" className="flex gap-2">
        {TABS.map((t) => {
          const active = pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              aria-current={active ? 'page' : undefined}
              className={`rounded-full px-4 py-2 text-sm transition-colors ${
                active
                  ? 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))] font-medium'
                  : 'border border-border text-muted-foreground hover:bg-muted/70 hover:text-foreground'
              }`}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
